import type { Rect } from './types';

/* eslint-disable no-restricted-syntax */
export function keyDiff<T>(a: Map<T, any>, b: Map<T, any>): Set<T> {
  const res = new Set<T>();

  for (const key of a.keys()) {
    if (!b.has(key)) {
      res.add(key);
    }
  }

  return res;
}

export function difference<T>(a: Map<T, any>, b: Map<T, any>) {
  const toRemove = keyDiff(a, b);
  const toAdd = keyDiff(b, a);
  return { toRemove, toAdd };
}

export function maxY(rect: Rect): number {
  return rect.y + rect.height;
}
